"use client";

import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import * as React from "react";

import { cn } from "@/lib/cn";

function Checkbox({ className, ...props }: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        // Size & shape
        "relative size-4 shrink-0 rounded-[0.25rem]",
        // Cursor
        "cursor-pointer",
        // Border
        "border-primary-800/56 border",
        // Checked state
        "data-[state=checked]:border-primary-500",
        // Focus state
        "focus-visible:ring-primary-500/50 focus-visible:ring-2 focus-visible:outline-none",
        // Hover state
        "hover:border-primary-500/80",
        "data-[state=checked]:hover:border-primary-400",
        // Disabled state
        "disabled:cursor-not-allowed disabled:opacity-50",
        // Transition
        "transition-colors",
        className
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="bg-primary-500 absolute top-1/2 left-1/2 size-2.5 -translate-x-1/2 -translate-y-1/2 rounded-[0.125rem]"
      />
    </CheckboxPrimitive.Root>
  );
}

export { Checkbox };
